import { useStyles, Button } from '@archipro-design/aria';
import { PenLight } from '@archipro-design/icons';
import * as S from './DetailPageButtons.style';
import { IslandTooltip } from './IslandTooltip';
import { useEditModeNavigation } from '~/modules/root/hook/use-edit-mode-navigation';

interface EditModeToggleProps {
    editLink: string;
}

export const EditModeToggle = ({ editLink }: EditModeToggleProps) => {
    const { css } = useStyles();
    const { isNavigating, start } = useEditModeNavigation(editLink);

    return (
        <IslandTooltip label="Switch to edit mode">
            <Button
                aria-label={
                    isNavigating
                        ? 'Switching to edit mode'
                        : 'Switch to edit mode'
                }
                id={'BMEditModeToggle'}
                className={
                    isNavigating
                        ? css(S.ActionButton, S.ActionButtonNavigating)
                        : css(S.ActionButton)
                }
                onClick={start}
                disabled={isNavigating}
                loading={isNavigating}
                aria-busy={isNavigating || undefined}
                // Keep the pencil mounted so size={20} still sets the button footprint.
                // Aria's loader is absolute and does not reserve layout space on its own.
                icon={
                    <PenLight
                        aria-hidden
                        className={
                            isNavigating
                                ? css(S.ActionButtonHiddenIcon)
                                : undefined
                        }
                    />
                }
                size={20}
                color="white"
                variables={{
                    iconPadding: 0,
                    // 13px at the 1920 design frame. In rem, not a raw px string,
                    // so it scales with the vw-anchored root like the numeric
                    // tokens do; it holds the circle at its original size now
                    // that the icon inside it is smaller.
                    buttonPadding: '0.8125rem',
                    buttonRadius: `50%`,
                }}
            />
        </IslandTooltip>
    );
};
